module.exports = __webpack_public_path__ + "img/tooltip-icon.df07d8fe.svg";